import {AfterViewInit, Component, OnInit} from '@angular/core';
import {NewsService} from "../../services/news.service";
import { DOCUMENT } from '@angular/platform-browser';
declare var jquery:any;
declare var $ :any;
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements AfterViewInit, OnInit  {
  title = 'app';
  noticias: any[]=[];
  documentos: any[]=[];
  importante: any[]=[];
  banner:any=[];
  show:string='none';
  dg1:any=[];
  dg2:any=[];
  popupVisible = false;
  texto:any;
  titulo:any;
  domain:string;
  position:any= { my: 'top', at: 'top', of: window, offset: '0 0' };
  videos:any=[];
  videoShow:boolean=false;
  showPopup:boolean=false;
  popupUrl:string;
  popupImage:string;
  video:any={Titulo:'xxx',Archivo:'',show:false,position:{ my: 'top', at: 'top', of: window, offset: '0 100' },Descripcion:''};
  styles: any= [
    {uri: '/assets/layerslider/css/layerslider.css'},
    {uri: 'https://fonts.googleapis.com/css?family=Montserrat:regular,700,900,100,200,300'},
    {uri: '/assets/layerslider/plugins/popup/layerslider.popup.css'}
  ];
  scripts: any= [
    {uri: '/assets/layerslider/js/greensock.js'},
    {uri: '/assets/layerslider/js/layerslider.transitions.js'},
    {uri: '/assets/layerslider/js/layerslider.kreaturamedia.jquery.js'},
    {uri: '/assets/layerslider/plugins/popup/layerslider.popup.js'}

  ];
  constructor(private news: NewsService) {

  }

  ngAfterViewInit(){
    let head = document.getElementsByTagName('head').item(0);

    let script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', '/assets/js/rellaxscript.js');
    head.appendChild(script);

    this.styles.forEach((currentValue, index, array) => {
      let script: any = document.createElement('link');
      script.setAttribute('rel', 'stylesheet');
      script.setAttribute('type', 'text/css');
      script.setAttribute('href', currentValue.uri);
      //head.appendChild(script);
    });
    this.scripts.forEach((currentValue, index, array) => {
      let script: any = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', currentValue.uri);
      //head.appendChild(script);
    });
    //console.log('HEADERS',head);

    this.news.getPopup().subscribe(response => {
        if(response.length>0){
          this.texto=response[0].Texto;
          this.titulo=response[0].Titulo;
          setTimeout(()=> {
            this.popupVisible = true;
          },3000);

        }

      },
      error => {
        console.log(<any>error);
      });


  }
  showVideo(item){
    let wWidth = window.screen.width;
    let w=600;
    if(wWidth<1024){
      w=300;
    }
    this.video=item;
    this.video.url='<iframe width=\"100%\" height=\"'+w+'\" src=\"https://www.youtube.com/embed/'+this.video.Archivo+'?autoplay=1\" frameborder=\"0\" allowfullscreen></iframe>';
    this.videoShow=true;
  }
  ngOnInit(){
    this.news.getNews().subscribe(response => {
        this.noticias= response[0];
        this.documentos= response[1];
        this.importante= response[3];
        this.videos= response[4];
        this.documentos.forEach((item, index) => {
            this.dg1.push({id:item.id,titulo:item.titulo,imagen:item.imagen});
        });
        this.noticias.forEach((currentValue, index, array)=> {
          var d=currentValue.imagen.split('.');
          currentValue.imagen=d[0]+='_nota.'+d[1];
        });
        setTimeout(()=>{
          this.show='block';
          this.test();
        },500);


      },
      error => {
        console.log(<any>error);
      });

    this.news.getConfig().subscribe(response => {
        this.domain = response.back_domain;
        this.showPopup = response.showPopup;
        this.popupUrl = response.url;
        this.popupImage = response.image;
      },
      error => {
        console.log(<any>error);
      });

  }
  callUrl(){
    window.location.href = this.popupUrl;
  }
  test(){
    $('.blog-carousel').owlCarousel({

      loop:true,
      autoplay:true,
      margin:30,
      nav:true,
      dots: false,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive:{
        0:{
          items:1
        },
        480:{
          items:2
        },
        767:{
          items:2
        },
        1000:{
          items:4
        }
      }
    });
    $('.img-carousel-content').owlCarousel({
      loop:true,
      autoplay:true,
      margin:30,
      nav:true,
      dots: false,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive:{
        0:{
          items:1
        },
        480:{
          items:2
        },
        767:{
          items:3
        },
        1000:{
          items:5
        }
      }
    });
    $('.testimonial-one').owlCarousel({
      loop:true,
      autoplay:true,
      margin:30,
      nav:true,
      dots: false,
      navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
      responsive:{
        0:{
          items:1
        },

        480:{
          items:1
        },

        767:{
          items:1
        },
        1000:{
          items:1
        }
      }
    });
    if(this.showPopup) {

      setTimeout(()=> {
        console.log('SLIDER POPUP');
        $('#slider').layerSlider({
          sliderVersion: '6.5.0b2',
          type: 'popup',
          autoStart: false,
          startInViewport: false,
          pauseOnHover: 'disabled',
          keybNav: false,
          touchNav: false,
          forceCycles: false,
          skin: 'noskin',
          globalBGSize: 'cover',
          navPrevNext: false,
          hoverPrevNext: false,
          navStartStop: false,
          navButtons: false,
          showCircleTimer: false,
          popupShowOnTimeout: 3,
          popupShowOnce: false,
          popupDisableOverlay: true,
          popupShowCloseButton: false,
          popupPositionVertical: 'top',
          popupDistanceLeft: 30,
          popupDistanceRight: 30,
          popupDistanceTop: 30,
          popupDistanceBottom: 30,
          popupDurationIn: 500,
          popupDelayIn: 0,
          popupTransitionOut: 'spin',
          skinsPath: '/assets/layerslider/skins/',
          plugins: ["popup"]
        });
      },5000);
    }
    $(".content").mCustomScrollbar({
      setWidth:false,
      setHeight:false,
      axis:"y",
    });


  }
}



// WEBPACK FOOTER //
// ./src/app/pages/index/index.component.ts